// extracted by mini-css-extract-plugin
export default {"switch-wrap":"Switch_switch-wrap__D2d+b","switch":"Switch_switch__D45GQ","switch-handle":"Switch_switch-handle__VQoSZ"};